export default __webpack_public_path__ + "static/media/water2.63a0e808.png";